const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export const formatRelativeTime = (iso: string, now = Date.now()) => {
  const date = new Date(iso);
  const elapsed = now - date.getTime();

  if (Number.isNaN(elapsed)) return "";
  if (elapsed < MINUTE) return "agora";
  if (elapsed < HOUR) return `${Math.floor(elapsed / MINUTE)} min`;
  if (elapsed < DAY) return `${Math.floor(elapsed / HOUR)} h`;
  if (elapsed < 7 * DAY) return `${Math.floor(elapsed / DAY)} d`;
  return date.toLocaleDateString("pt-BR", { day: "2-digit", month: "short" });
};

